import { uid } from 'uid';
import { LitElement, html } from 'lit';

import componentStyles from './fil-show-more.styles.js';

/**
 * @tag fil-show-more
 * @property {string}[label] Text to be displayed when showing the content. Default is 'Read more'.
 * @property {string}[labelCollapse] Text to be displayed when collapsing or hiding the content. Default is 'Read less'.
 * @property {boolean}[toggle] Determines whether the component supports more/less behavior.
 */
export class FilShowMore extends LitElement {
  static properties = {
    label: { type: String },
    labelCollapse: { type: String },
    toggle: { type: Boolean },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.label = 'Read more';
    this.labelCollapse = 'Read less';

    this.uid = uid();
  }

  /**
   * Handles the click event on the label.
   * Toggles the checked state of the associated checkbox and updates the label.
   */
  handleClick(e) {
    const checkbox = this.renderRoot.querySelector('input');
    if (!checkbox.getAttribute('checked') && !this.toggle) {
      checkbox.setAttribute('checked', true);
      return;
    }
    if (checkbox.getAttribute('checked')) {
      checkbox.removeAttribute('checked');
      e.target.setAttribute('data-label', this.label);
      e.target.setAttribute('aria-label', this.label);
    } else {
      checkbox.setAttribute('checked', true);
      e.target.setAttribute('data-label', this.labelCollapse);
      e.target.setAttribute('aria-label', this.labelCollapse);
    }
  }

  render() {
    return html`<div class="fil-show-more-wrapper">
      <input id="${this.uid}" type="checkbox" />
      <div class="fil-show-more--content">
        <slot
          @slotchange=${() => {
            // event will be triggered if <slot> is filled
            // show/hide "label' when necessary
          }}
        ></slot>
      </div>
      <label
        for="${this.uid}"
        data-label="${this.label}"
        tabindex="0"
        ?data-toggle=${this.toggle}
        @click=${this.handleClick}
        @keydown=${e => {
          if (e.key === 'Enter' || e.key === ' ') {
            this.handleClick(e);
          }
        }}
      ></label>
    </div>`;
  }
}

export default FilShowMore;
